import { useAuthenticatedContext } from '../../../../container';
import {
    SegmentListViewProps,
    SegmentItemControllerProps,
} from '../../../view/dashboard';
import { AnyFilter } from '../../../domain/dashboard';
import { isCurrencyType } from '../../../domain/attributes';
import {
    useControlApi,
    useQueryApi,
    useDashboardApi,
    useDashboardStateApi,
} from '../../../app/dashboard';

export interface SegmentListViewController {
    (): Omit<SegmentListViewProps, 'renderItem'>;
}

export interface SegmentItemViewController {
    (filter: AnyFilter, index: number): SegmentItemControllerProps;
}

export const useSegmentListController: SegmentListViewController = () => {
    const api = {
        dashboard: useDashboardApi(),
        query: useQueryApi(),
    };
    return {
        hash: api.query.getSegmentHash(),
        value: api.query.getSegment(),
        filters: api.dashboard.getTraits(),
    };
};

export const useSegmentItemController: SegmentItemViewController = (filter, index) => {
    const appcontext = useAuthenticatedContext();
    const api = {
        dashboard: useDashboardApi(),
        query: useQueryApi(),
        state: useDashboardStateApi(),
        control: useControlApi(),
    };
    return {
        isDisabled: filter.property.isDisabled,
        disabledReason: filter.property.disabledReason,
        disclosure: {
            isOpen: api.state.isExpanded(filter),
            onToggle: api.state.toggleExpanded.bind(null, filter),
        },
        filter,
        hash: api.query.getSegmentHash(),
        value: api.control.getSegmentFilterValue(filter) ?? null,
        onClear() {
            api.control.setSegmentFilterValue(filter, null);
            return;
        },
        onChange(condition) {
            if (Array.isArray(condition.value) && condition.value.length === 0) {
                api.control.clearSegmentFilterValue(filter);
                return;
            }
            api.control.setSegmentFilterValue(filter, {
                key: filter.property.key,
                operator: filter.default.operator,
                value: condition.value,
            });
        },
        format(type, value, options) {
            if (isCurrencyType(type) && typeof value === 'number') {
                return appcontext.formatter.currency(value, type.currency, options);
            }
            // @ts-expect-error
            return value.toString();
        },
        getInputProps(props) {
            return props;
        },
    };
};
